import {useEffect, useState} from "react";
import {COMMON_RANGE, type AxisRange, zoomXRange} from "../chartRange";
import {useI18n} from "../i18n";

export function ChartControls({range, onRange, fullRange, logarithmic, onLog, xLog = false, onXLog, disabled}: {
  range: AxisRange; onRange: (range: AxisRange) => void; fullRange: AxisRange;
  xLog?: boolean; onXLog?: (value: boolean) => void;
  logarithmic: boolean; onLog: (value: boolean) => void; disabled: boolean;
}) {
  const {t, locale} = useI18n();
  const [min, setMin] = useState(String(range[0])), [max, setMax] = useState(String(range[1]));
  useEffect(() => {setMin(String(Number(range[0].toPrecision(6)))); setMax(String(Number(range[1].toPrecision(6))));}, [range]);
  const valid = min.trim() !== "" && max.trim() !== "" && Number.isFinite(+min) && Number.isFinite(+max) && (xLog ? +min > 0 : +min >= 0) && +max > +min;
  return <div className="chart-controls">
    <div className="plot-toolbar">
      <div role="group" aria-label={t("temperatureRange")}>
        <button disabled={disabled} onClick={() => onRange([...COMMON_RANGE])}>{t("commonRange")}</button>
        <button disabled={disabled} onClick={() => onRange([0, 20])}>{t("lowTemperature")}</button>
        <button disabled={disabled} onClick={() => onRange(fullRange)}>{t("fitData")}</button>
      </div>
      <div role="group" aria-label={t("zoomControls")}>
        <button disabled={disabled} aria-label={t("zoomIn")} title={t("zoomIn")} onClick={() => onRange(zoomXRange(range, .5, xLog))}>＋</button>
        <button disabled={disabled} aria-label={t("zoomOut")} title={t("zoomOut")} onClick={() => onRange(zoomXRange(range, 2, xLog))}>−</button>
        <button disabled={disabled} onClick={() => onRange([...COMMON_RANGE])}>{t("reset")}</button>
      </div>
    </div>
    <div className="range-row">
      <form onSubmit={event => {event.preventDefault(); if (valid) onRange([+min, +max]);}}>
        <span>Tt (eV)</span>
        <input aria-label={t("rangeMin")} type="number" step="any" min="0" value={min} onChange={event => setMin(event.target.value)} disabled={disabled}/>
        <span>–</span>
        <input aria-label={t("rangeMax")} type="number" step="any" value={max} onChange={event => setMax(event.target.value)} disabled={disabled}/>
        <button disabled={disabled || !valid}>{t("apply")}</button>
      </form>
      <div role="group" aria-label={locale === "zh-CN" ? "横轴坐标" : "X axis scale"}><span>{locale === "zh-CN" ? "横轴" : "X axis"}</span><button aria-pressed={!xLog} onClick={() => onXLog?.(false)}>{t("linear")}</button><button aria-pressed={xLog} onClick={() => onXLog?.(true)}>{t("log")}</button></div>
      <div role="group" aria-label={t("yScale")}><span>{t("yScale")}</span><button aria-pressed={!logarithmic} onClick={() => onLog(false)}>{t("linear")}</button><button aria-pressed={logarithmic} onClick={() => onLog(true)}>{t("log")}</button></div>
    </div>
    {xLog && <p className="chart-help">{locale === "zh-CN" ? "对数横轴仅显示正温度；常用范围自动从正值开始。" : "Log X displays positive temperatures only."}</p>}
    {!valid && <p role="status" className="range-error">{t("rangeError")}</p>}
    {!disabled && <p className="chart-help">{t("chartHelp")}</p>}
  </div>;
}
